import DashboardCharts from '../../templates/dashboard';
import FilterForm from '../../templates/dashboard/filterForm';
import Layout from '../Layout';

const Index = () => {
  return (
    <Layout>
      <div className="gradient-background">
        <div className="w-full">
          <span className="font-semibold text-2xl text-white">Dashboard</span>
          <FilterForm />
          <DashboardCharts />
        </div>
      </div>
    </Layout>
  );
};

export default Index;
